import { API_URLS_LIST } from '@config/api-config';
import axiosInstance from '@services/api/axios-wrapper-service';
import axiosInstanceNSpinner from '@services/api/axios-wrapper-nospinner-service';

export const authenticate = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.LOGIN, request);
};

export const refreshToken = (): Promise<any> => {
  return axiosInstanceNSpinner.get(API_URLS_LIST.refreshToken);
};

export const experienceRules = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.GETEXPERIENCERULES, request);
};

export const getCCEsFromService = (userId: string): Promise<any> => {
  return axiosInstance.get(API_URLS_LIST.getCCEs + '?userId=' + userId);
};


export const authorize = (request: any): Promise<any> => {
  const { protocol, hostname, port } = window.location;
  const url = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  return axiosInstance.post(API_URLS_LIST.authorize, 
    request,
    {
      baseURL: url,
    });
};

export const authorizeOIDC = (): Promise<any> => {
  const { protocol, hostname, port } = window.location;
  const url = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  return axiosInstance.post(API_URLS_LIST.authorize, 
    {
      // Request body for OIDC authentication
      authType: 'OIDC'
    },
    {
      baseURL: url,
    });
};

export const logout = (): Promise<any> => {
  return axiosInstance.get(API_URLS_LIST.logout);
};

